/**
 * Auto-written by `scripts/lib/pwa-client.cjs` on pwa:dev / build-pwa.
 * Do not hand-edit — re-run the sync command for another client.
 */
export const generated_pwa_client = {
  "index": 1,
  "appName": "Live Update",
  "identifier": "testing",
  "appId": "com.merak.internal",
  "themeColor": "#0f172a",
  "backgroundColor": "#0b1220",
  "versionIos": "1013",
  "versionAndroid": "1013"
} as const;
